import CourseContentLayoutStudent from "./CourseContentLayoutStudent";

function JuniorCourse(props) {
  return <CourseContentLayoutStudent {...props} totalModules={3} />;
}

export default JuniorCourse;